import { render, staticRenderFns } from "./settings-list.vue?vue&type=template&id=622d25b3&"
import script from "./settings-list.vue?vue&type=script&lang=js&"
export * from "./settings-list.vue?vue&type=script&lang=js&"
import style0 from "./settings-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports